import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '900px', margin: 'auto', lineHeight: '1.8', color: '#333' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Privacy Policy – NeatnClean</h1>
      <p><strong>Effective Date:</strong> [11 Aug 2025]</p>

      <h2>1. Information We Collect</h2>
      <p>We collect certain information when you interact with our website, app, or services:</p>
      <ul>
        <li><strong>Personal Information:</strong> Name, email, phone number, address, and payment details.</li>
        <li><strong>Usage Data:</strong> Device type, browser, IP address, and user interaction data.</li>
        <li><strong>Cookies:</strong> Used to improve user experience. You can disable them via browser settings.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To process laundry service orders including pickup and delivery.</li>
        <li>To communicate order updates, invoices, and promotional offers (if opted in).</li>
        <li>To enhance website performance and service efficiency.</li>
        <li>To comply with legal obligations or prevent fraud.</li>
      </ul>

      <h2>3. Data Sharing and Disclosure</h2>
      <p>We do <strong>not sell</strong> your data. We may share limited information with:</p>
      <ul>
        <li>Delivery partners for logistics coordination.</li>
        <li>Payment processors for secure transactions.</li>
        <li>IT and cloud service providers for website and database management.</li>
        <li>Law enforcement or regulatory agencies when required by law.</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>We use secure servers, encrypted data storage, and limited access controls to protect your information. However, no system is completely immune to risks.</p>

      <h2>5. Your Rights</h2>
      <p>You may request:</p>
      <ul>
        <li>Access to the data we hold about you.</li>
        <li>Corrections to your information.</li>
        <li>Deletion of your account or data (subject to regulations).</li>
        <li>To opt-out of promotional communications at any time.</li>
      </ul>
      <p>Email us at <a href="mailto:support@neatnclean.in">support@neatnclean.in</a> to exercise your rights.</p>

      <h2>6. Third-Party Links</h2>
      <p>Our website or app may link to external websites. We are not responsible for their privacy practices. Please review their policies independently.</p>

      <h2>7. Children’s Privacy</h2>
      <p>NeatnClean does not knowingly collect personal data from individuals under the age of 18. If we become aware of such data, we will delete it immediately.</p>

      <h2>8. Policy Updates</h2>
      <p>We may update this Privacy Policy periodically. Changes will be posted on this page with a new effective date.</p>

      <h2>9. Contact Us</h2>
      <p>If you have any questions or concerns, please reach out to us at:</p>
      <p>
        📧 Email: <a href="mailto:support@neatnclean.in">support@neatnclean.in</a><br />
        📍 Address: H-16/431, Sangam Vihar, Hamdard Nagar, South Delhi, New Delhi, Delhi, India, 110062<br />
        📞 Phone: [+919654335152]
      </p>
    </div>
  );
};

export default PrivacyPolicy;
